import { render, staticRenderFns } from "./StepBadge.vue?vue&type=template&id=55ba6520&scoped=true&lang=pug"
import script from "./StepBadge.vue?vue&type=script&lang=js"
export * from "./StepBadge.vue?vue&type=script&lang=js"
import style0 from "./StepBadge.vue?vue&type=style&index=0&id=55ba6520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ba6520",
  null
  
)

export default component.exports